(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .directive('actionPlanReviewSelector', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                actionPlanAssessments: '='
            },
            restrict: 'AE',
            templateUrl: require('./actionPlanSelector.tpl.html'),
            controller: ['$scope', '$state', '$stateParams',
                function ($scope, $state, $stateParams) {

                    $scope.isActionPlanActive = function (actionPlanAssessment) {
                        return actionPlanAssessment.ActionPlan.ActionPlanID === $stateParams.ActionPlanID;
                    };

                    $scope.goToActionPlan = function (actionPlanAssessment) {
                        $state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias', {
                            ActionPlanID: actionPlanAssessment.ActionPlan.ActionPlanID
                        });
                    };
                }]
        };
    }
})();